export default "__VITE_ASSET__Cr1l_7$S__"